import React from 'react';

import ReadListView from 'features/messengerv2/ReadListView';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Icon from 'components/Icon';
import Text from 'components/Text';

import { cxFunction } from 'util/className';

const ReadList = ({ cx, cxEl, teamAnnouncement, onClose }) => {
  function renderHeader() {
    return (
      <Box row p={20}>
        <Box>
          <Button
            className={cxEl('close')}
            theme="link-purple"
            icon="closeSimple"
            onClick={onClose}
          />
        </Box>
        <Box>
          <Text
            fs18
            fw600
            lh={1.1}
            i18n="message_drawer.team_announcements.acknowledged_block.title"
          />
        </Box>
        <Box hright grow>
          <Box row>
            <Box>
              <Icon
                className={cxEl('icon', 'read-count')}
                size={16}
                color="blue"
                type="success"
              />
            </Box>
            &nbsp;
            <Box>
              <Text fs18 fw400 color="blue">
                {teamAnnouncement.get('acknowledged_count')}&nbsp;/&nbsp;
                {teamAnnouncement.get('recipients_count')}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={cx()}
      absolute
      bottom={0}
      left={0}
      w="100%"
      bg="white"
      muiShadow
      overflow="auto"
      maxh={435}
      minh={435}
      z={2}
    >
      {renderHeader()}

      <Box scrollY className={cxEl('body')}>
        <ReadListView
          cxEl={cxEl}
          readParticipants={teamAnnouncement
            .get('recipients')
            .filter(a => a.get('read_at_secs'))
            .toJSON()}
          unreadParticipants={teamAnnouncement
            .get('recipients')
            .filter(a => !a.get('read_at_secs'))
            .toJSON()}
          i18nPath="message_drawer.team_announcements.acknowledged_block"
          readIcon="success"
          hasAccess
        />
      </Box>
    </Box>
  );
};

export default cxFunction('ReadList', ReadList);
